import { MainMagicShortcutType } from "../components/main-page/Shortcuts";

export const DEFAULT_TXT = "---";

export enum PAY_TYPE_ENUM {
  monthly = "monthly",
  yearly = "yearly",
}

export const PAY_TYPE_MAP = {
  monthly: "一月99¥",
  yearly: "一年299¥",
};

// on going / success / failed / refund
export enum PAY_STATE_ENUM {
  onGoing = "on going",
  success = "success",
  failed = "failed",
  refund = "refund",
}

export const PAY_STATE_MAP = {
  onGoing: "支付中...",
  success: "支付成功",
  failed: "支付失败",
  refund: "退款",
};

export enum DRAW_TYPE_ENUM {
  paint = "paint",
  eraser = "eraser",
  lasso = "lasso",
  segment = "segment",
}

export enum SEGMENT_TYPE_ENUM {
  rmbg = "rmbg",
  face = "face",
  clothe = "clothe",
}

export enum CLOTHE_SEGMENT_TYPE_ENUM {
  whole = "whole",
  upper_long = "upper_long",
  upper_short = "upper_short",
  down_short = "down_short",
  down_long = "down_long",
  low_cover_big = "low_cover_big",
}

export enum SEGMENT_TYPE_DISPLAY_ENUM {
  inProgress = "分割中...",
  rmbg = "背景",
  face = "面部",
  clothe = "衣服",
  upper_long = "长袖上衣",
  upper_short = "短袖上衣",
  down_short = "短裤",
  down_long = "长裤",
  low_cover_big = "长裙",
}

// 参考图
export enum REFER_SEGMENT_TYPE_ENUM {
  lasso = "lasso",
  rmbg = "rmbg",
  other = "other",
}

export enum INFER_TASK_TYPE_ENUM {
  imageToVideo = "image to video",
  editWithPrompt = "edit with prompt",
  segmentAny = "segment any",
  replaceWithReference = "replace with reference",
  replaceAny = "replace any",
}

export enum INFER_TASK_TYPE_DISPLAY_ENUM {
  imageToVideo = "图生视频",
  editWithPrompt = "万能修图",
  segmentAny = "分割",
  replaceWithReference = "精准修图-参考图",
  replaceAny = "精准修图",
}

export enum INFER_TASK_STATUS_ENUM {
  failed = "failed",
  waiting = "waiting",
  inProgress = "in progress",
  down = "down",
  canceled = "canceled",
}

export enum INFER_TASK_STATUS_HISTORY_ENUM {
  failed = "任务失败，因为各种原因",
  waiting = "任务还在排队等待",
  inProgress = "任务已经发送给推理服务，正在等待推理服务响应",
  down = "任务已经成功得到推理结果",
  canceled = "等待中的任务已经取消",
}

export enum INFER_TASK_STATUS_DISPLAY_ENUM {
  failed = "任务失败",
  waiting = "取消任务",
  inProgress = "生成中...",
  down = "施法",
}

export enum MAGIC_TYPE_ENUM {
  partial = "partial",
  powerful = "powerful",
  video = "video",
}

export enum MAGIC_TYPE_DISPLAY_ENUM {
  partial = "精准修",
  powerful = "万能修",
  video = "图生视频",
}

export enum MAGIC_API_CALL_POINT_ENUM {
  segment = 1,
  partial = 10,
  powerful = 10,
  superPowerful = 15,
  video = 30,
}

export enum API_ERR_CODE_ENUM {
  inferServerUnavailable = 1,
  taskCanceled = 5,
  noSuchBackgroundRequest = 4,
  notEnoughPoint = 3,
  unauthorized = 401,
  requestEntityTooLarge = 413,
  notFound = 404,
  internalServerError = 500,
  canceledByAdmin = 10,
}

export enum API_ERR_CODE_DISPLAY_ENUM {
  inferServerUnavailable = `服务暂不可用`,
  taskCanceled = `任务已取消`,
  noSuchBackgroundRequest = `没有这个服务`,
  notEnoughPoint = `魔法值不足`,
  unauthorized = `请重新登陆`,
  requestEntityTooLarge = `请求实体太大`,
  notFound = `未找到请求的资源`,
  internalServerError = `内部服务器错误`,
  canceledByAdmin = `已被管理员取消`,
}

export enum MAGIC_SHORTCUT_TYPE_ENUM {
  changeBackground = "更换背景",
  changeWeather = "变换天气",
  withoutCrowds = "消除人群",
}

export enum MAGIC_SHORTCUT_PARAM_TYPE_ENUM {
  required = "required",
  optional = "optional",
}

export const MAGIC_PARTIAL_OP_TABS = ["原图", "重绘区", "参考提示", "生成"];

export const MAGIC_OTHER_OP_TABS = ["原图", "参考提示", "生成"];

// mask图 涂抹
export const DEFAULT_LINE_COLOR = "#FFFFFF"; // 白色
export const DEFAULT_ERASER_COLOR = "#000000";
export const DEFAULT_LINE_WIDTH = 10; // 10% of canvas width

export const DEFAULT_LASSO_LINE_WIDTH = 2; // 2% of canvas width

export const DEFAULT_MASK_CANVAS_OPACITY = 0.5;

// 主页 - 滚动图片列表
export const MAIN_TEACHING_EXAMPLES = [
  {
    image: "videos/teach-magic-1.jpg",
    video: "videos/teach-video-1.mp4",
  },
  {
    image: "videos/teach-magic-2.jpg",
    video: "videos/teach-video-2.mp4",
  },
];

// 主页 - 快捷功能列表
export const MAIN_MAGIC_SHORTCUTS: MainMagicShortcutType[] = [
  {
    type: MAGIC_SHORTCUT_TYPE_ENUM.changeWeather,
    magic: "magicShortcut/changeWeatherMagic.png",
    teach: "magicShortcut/changeWeatherTeach.png",
    params: {
      magic_type: MAGIC_TYPE_ENUM.powerful,
      init_image: MAGIC_SHORTCUT_PARAM_TYPE_ENUM.required,
      prompt:
        "The weather turned into a blizzard, with heavy snowflakes falling. The snow was pristine white.",
    },
  },
  {
    type: MAGIC_SHORTCUT_TYPE_ENUM.withoutCrowds,
    magic: "magicShortcut/removeCrowdsMagic.png",
    teach: "magicShortcut/removeCrowdsTeach.png",
    params: {
      magic_type: MAGIC_TYPE_ENUM.powerful,
      init_image: MAGIC_SHORTCUT_PARAM_TYPE_ENUM.required,
      prompt: "without crowds",
    },
  },
  {
    type: MAGIC_SHORTCUT_TYPE_ENUM.changeBackground,
    magic: "magicShortcut/changeBackgroundMagic.png",
    teach: "magicShortcut/changeBackgroundTeach.png",
    params: {
      magic_type: MAGIC_TYPE_ENUM.partial,
      init_image: MAGIC_SHORTCUT_PARAM_TYPE_ENUM.required,
      segment_prompt: SEGMENT_TYPE_ENUM.rmbg, // SEGMENT_TYPE_ENUM or CLOTHE_SEGMENT_TYPE_ENUM
      refer_image: MAGIC_SHORTCUT_PARAM_TYPE_ENUM.optional, // required or optional
      prompt: "",
    },
  },
];

// 主页 - 魔法展示列表
export const MAGIC_IMG_EXAMPLES = [
  {
    btnLabel: MAGIC_TYPE_DISPLAY_ENUM.partial,
    fileURIs: [
      ["images/partial-origin-1.png", "images/partial-magic-1.png"],
      ["images/partial-origin-2.png", "images/partial-magic-2.png"],
    ],
    disabled: false,
    type: MAGIC_TYPE_ENUM.partial,
  },
  {
    btnLabel: MAGIC_TYPE_DISPLAY_ENUM.powerful,
    fileURIs: [
      ["images/powerful-origin-1.png", "images/powerful-magic-1.png"],
      ["images/powerful-origin-2.png", "images/powerful-magic-2.png"],
    ],
    disabled: false,
    type: MAGIC_TYPE_ENUM.powerful,
  },
  {
    btnLabel: MAGIC_TYPE_DISPLAY_ENUM.video,
    fileURIs: [
      ["videos/freezetime.jpg", "videos/freezetime.mp4"],
      ["videos/kongfu.jpg", "videos/kongfu.mp4"],
    ],
    disabled: false,
    type: MAGIC_TYPE_ENUM.video,
  },
];

export const SUCCESS_CODE_API = 0;
export const GALLERY_HISTORY_ROWS_PER_PAGE_DEFAULT = 10;

export const ERR_MSG_NOT_LOGIN = `未登陆`;

export const ERR_MSG_UNKNOWN = "未知错误";
export const ERR_MSG_AT_LEAST_NEED_TEXT_PROMPT = `至少需要填写提示词`;

export const API_USER_INFO = "/aigc/api/user/info";
export const ERR_MSG_FAIL_GET_USER_INFO = `获取用户信息失败`;
export const ERR_MSG_GET_USER_INFO = `获取用户信息出错`;

export const ERR_MSG_FAIL_REFRESH_USER_INFO = `刷新用户信息失败`;
export const ERR_MSG_REFRESH_USER_INFO = `刷新用户信息出错`;

export const ERR_MSG_GET_USER_HISTORY = `获取用户历史出错`;

// 同步推理接口
export const API_INFER_REPLACE_WITH_REFERENCE =
  "/aigc/api/infer/replace_with_reference";
export const API_INFER_REPLACE_ANY = "/aigc/api/infer/replace_any";
export const API_INFER_SEGMENT_ANY = "/aigc/api/infer/segment_any";

// 异步推理接口
export const API_ASYNC_INFER_SEGMENT_ANY = "/aigc/api/async/infer/segment_any";
export const API_ASYNC_INFER_REPLACE_WITH_REFERENCE =
  "/aigc/api/async/infer/replace_with_reference";
export const API_ASYNC_INFER_REPLACE_ANY = "/aigc/api/async/infer/replace_any";
export const API_ASYNC_INFER_VIDEO = "/aigc/api/async/infer/image_to_video";
export const API_ASYNC_INFER_EDIT_WITH_PROMPT =
  "/aigc/api/async/infer/edit_with_prompt";

/* 施法 */
export const ERR_MSG_FAIL_REPLACE = `生成魔法图失败`;
export const ERR_MSG_REPLACE = `生成魔法图出错`;
export const ERR_MSG_NOT_GET_ORIGIN_BASE64 = `未获得原图数据`;
export const ERR_MSG_NOT_GET_MASH_BASE64 = `未获得重绘区涂抹数据`;
export const ERR_MSG_NOT_GET_REFER = `未获得参考图数据！或者，未填写提示词`;
export const ERR_MSG_NOT_GET_REFER_TEXT = `未填写提示词`;

/* 分割 */
export const ERR_MSG_LASSO_POINTS_NOT_ENOUGH = `套索点不足3个`;
export const ERR_MSG_FAIL_SEGMENT = `分割失败`;
export const ERR_MSG_SEGMENT = `分割出错`;

export const API_PAYMENT_OPEN = "/aigc/api/payment/open";
export const ERR_MSG_UNKNOWN_PAYMENT = "未知订单";
export const ERR_MSG_UNKNOWN_PAYMENT_STATUS = `未知订单支付状态`;
// 单位是分，100代表1元
export const MONTH_PAY_CENT = 99 * 100;
export const ERR_MSG_FAIL_MONTH_PAY = `生成月支付订单失败`;
export const ERR_MSG_MONTH_PAY = `生成月支付订单出错`;
// 单位是分，100代表1元
export const YEAR_PAY_CENT = 299 * 100;
export const ERR_MSG_FAIL_YEAR_PAY = `生成年支付订单失败`;
export const ERR_MSG_YEAR_PAY = `生成年支付订单出错`;

export const API_PAYMENT_STATE = "/aigc/api/payment/state";
export const ERR_MSG_FAIL_GET_PAYMENT_STATUS = `查询支付订单状态失败`;
export const ERR_MSG_GET_PAYMENT_STATUS = `查询支付订单状态失败`;

export const ERR_MSG_NOT_GET_REFER_BASE64 = `未获得参考图数据`;
export const ERR_MSG_FAIL_SEGMENT_REFER = `前景分割失败`;
export const ERR_MSG_SEGMENT_REFER = `前景分割出错`;

export const ERR_MSG_REFER_LASSO_POINTS_NOT_ENOUGH = "点选分割至少需要3个点";

export const ERR_MSG_NO_TASK_ID = `未获得任务ID`;

export const API_GET_MAIN_BANNER = `/aigc/api/main/banner`;
export const ERR_MSG_FAIL_GET_MAIN_BANNER = `获取主页轮播图片失败`;
export const ERR_MSG_GET_MAIN_BANNER = `获取主页轮播图片出错`;

export const API_GET_MAIN_MAGIC = `/aigc/api/main/magic`;
export const ERR_MSG_FAIL_GET_MAIN_MAGIC = `获取主页展示图片/视频失败`;
export const ERR_MSG_GET_MAIN_MAGIC = `获取主页展示图片/视频出错`;

export const API_GET_MAIN_MAGIC_SHORTCUT = `/aigc/api/main/shortcut`;
export const ERR_MSG_FAIL_GET_MAIN_MAGIC_SHORTCUT = `获取主页快捷功能列表失败`;
export const ERR_MSG_GET_MAIN_MAGIC_SHORTCUT = `获取主页快捷功能列表出错`;

export enum ORIGIN_ACTIONS_ENUM {
  brightness = "亮度",
  contrast = "对比度",
  saturate = "饱和度",
  grayscale = "灰度",
  rotate = "旋转",
  zoom = "缩放",
}

export enum ORIGIN_MASK_ACTIONS_ENUM {
  paint = "涂抹",
  eraser = "橡皮擦",
  lasso = "套索",
  segment = "分割",
}

export enum ORIGIN_MASK_SEGMENT_ACTIONS_ENUM {
  rmbg = "背景",
  face = "面部",
  clothe = "衣服",
  upper_long = "长袖上衣",
  upper_short = "短袖上衣",
  down_short = "短裤",
  down_long = "长裤",
  low_cover_big = "长裙",
}

export enum REFERENCE_ACTIONS_ENUM {
  zoom = "缩放",
  brightness = "亮度",
  rotate = "旋转",
  lasso = "点选分割",
  segment = "前景分割",
}

export enum MAX_UPLOAD_IMG_SIZE_ENUM {
  width = 4096,
  height = 4096,
}

export enum DEFAULT_TXT_IMG_SIZE_ENUM {
  width = 1920,
  height = 1080,
}
